import React from 'react';

import styled from '@emotion/styled';

import UserIcon from '../../../../components/Icons/UserIcon';
import { Modal } from '../../../../components/Modals/Modal';
import ApplicantProfileModal from '../../../../components/Modals/ModalsActions/ApplicantProfileModal';
import ModalTriggerContainer from '../../../../components/Modals/ModalTriggerContainer';
import { ModalProvider } from '../../../../context/ModalContext';

const ShowApplicantModal = ({
  applicantId,
  applicationId,
  resume,
}: {
  applicantId: string;
  applicationId: string;
  resume: string;
}) => {
  return (
    <ModalProvider>
      <ModalTriggerContainer>
        <IconWrapper>
          <UserIcon />
        </IconWrapper>
      </ModalTriggerContainer>
      <Modal>
        <ApplicantProfileModal
          applicantId={applicantId}
          applicationId={applicationId}
          resume={resume}
        />
      </Modal>
    </ModalProvider>
  );
};

export default ShowApplicantModal;

const IconWrapper = styled.div`
  cursor: pointer;
`;
